// extracted by mini-css-extract-plugin
export default {"PfsPanel":"PFSPanel_PfsPanel__StXum"};